/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";


export const getUnassignedTxn = createAsyncThunk(
  "settlement/getUnassignedTxn",
  async () => {
    const response = await axios.get(`/api/admin/getUnassignedTxn`);
    return response.response;
  }
);

export const getOverdueTransactions = createAsyncThunk(
  "settlement/getOverdueTransactions",
  async () => {
    const response = await axios.get(`/api/admin/getOverdueTransactions`);
    return response.response;
  }
);

export const getRepaidTransactions = createAsyncThunk(
  "settlement/getRepaidTransactions",
  async () => {
    const response = await axios.get(`/api/admin/getRepaidTransactions`);
    return response.response;
  }
);

export const getSettledTransactions = createAsyncThunk(
  "settlement/getSettledTransactions",
  async () => {
    const response = await axios.get(`/api/admin/getSettledTransactions`);
    return response.response;
  }
);

export const getAssignTxn = createAsyncThunk(
  "settlement/getAssignTxn",
  async (txnId) => {
    const response = await axios.get(`/api/admin/getAssignTxn?txnId=${txnId}`);
    return response.response;
  }
);

export const settleTxn = createAsyncThunk(
  "settlement/settleTxn",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/settleTxn`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const settlePreview = createAsyncThunk(
  "settlement/settlePreview",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/settlePreview`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const SettlementSlice = createSlice({
  name: "settlement",
  initialState: {
    loading: false,
    error: "",
    unassignedTxn: [],
    overdueTxn: [],
    repaidTxn: [],
    settledTxn: [],
    settleTxnSummary: {},
    settleBreakUpLoading: false,
    settleBreakUp: {},
    dealIdAssigned: false,
    settleLoading: false,
  },

  extraReducers: (builder) => {
    builder.addCase(getUnassignedTxn.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnassignedTxn.fulfilled, (state, action) => {
      state.loading = false;
      state.unassignedTxn = action.payload;
    });
    builder.addCase(getUnassignedTxn.rejected, (state, action) => {
      state.loading = false;
      state.unassignedTxn = [];
    });

    builder.addCase(getOverdueTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverdueTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.overdueTxn = action.payload;
    });
    builder.addCase(getOverdueTransactions.rejected, (state, action) => {
      state.loading = false;
      state.overdueTxn = [];
    });

    builder.addCase(getRepaidTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRepaidTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.repaidTxn = action.payload;
    });
    builder.addCase(getRepaidTransactions.rejected, (state, action) => {
      state.loading = false;
      state.repaidTxn = [];
    });

    builder.addCase(getSettledTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSettledTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.settledTxn = action.payload;
    });
    builder.addCase(getSettledTransactions.rejected, (state, action) => {
      state.loading = false;
      state.settledTxn = [];
    });

    builder.addCase(getAssignTxn.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAssignTxn.fulfilled, (state, action) => {
      state.loading = false;
      state.settleTxnSummary = action.payload;
    });
    builder.addCase(getAssignTxn.rejected, (state, action) => {
      state.loading = false;
      state.settleTxnSummary = {};
    });

    builder.addCase(settleTxn.pending, (state) => {
      state.settleLoading = true;
      state.error = "";
    });
    builder.addCase(settleTxn.fulfilled, (state, action) => {
      state.settleLoading = false;
      state.error = "";
    });
    builder.addCase(settleTxn.rejected, (state, action) => {
      state.settleLoading = false;
      state.error = action.payload;
    });

    builder.addCase(settlePreview.pending, (state) => {
      state.settleBreakUpLoading = true;
      state.error = "";
    });
    builder.addCase(settlePreview.fulfilled, (state, action) => {
      state.settleBreakUpLoading = false;
      state.settleBreakUp = action.payload.response;
    });
    builder.addCase(settlePreview.rejected, (state, action) => {
      state.settleBreakUpLoading = false;
      state.settleBreakUp = {};
      state.error = action.payload;
    });
  },

  reducers: {}
});

export const { } = SettlementSlice.actions;

export default SettlementSlice.reducer;
